module.exports = __webpack_public_path__ + "assets/img/fac60bbed776dd64cc99be66074fb3cf.png";